import {
  addLoading,
  deleteMemberAsync,
  forceLogout,
  hideAlert,
  hideConfirm,
  logout,
  removeLoading,
  showConfirm,
  showError,
  showSuccess,
  memberRegisterAsync,
  memberUpdateAsync,
  toggleMenu,
  userRegisterAsync,
  dbConfigAsync,
  login,
} from '@redux/actions';
import { createSlice } from '@reduxjs/toolkit';

const initialState: AppState = {
  openMenu: false,
  loadingCount: 0,
  alert: { show: false },
  dialogConfirm: { show: false },
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(toggleMenu, (state) => {
        state.openMenu = !state.openMenu;
      })
      .addCase(addLoading, (state) => {
        state.loadingCount++;
      })
      .addCase(removeLoading, (state) => {
        state.loadingCount--;
      })
      .addCase(showError, (state, { payload }) => {
        state.alert = {
          show: true,
          type: 'error',
          ...payload,
        };
      })
      .addCase(showSuccess, (state, { payload }) => {
        state.alert = {
          show: true,
          type: 'success',
          ...payload,
        };
      })
      .addCase(hideAlert, (state) => {
        state.alert.show = false;
      })
      .addCase(showConfirm, (state, { payload }) => {
        state.dialogConfirm = {
          show: true,
          ...payload,
        };
      })
      .addCase(hideConfirm, (state) => {
        state.dialogConfirm.show = false;
      })
      .addCase(forceLogout, (state) => {
        state.alert = {
          show: true,
          type: 'warning',
          message: 'MSW00003',
        };
      })
      .addCase(login.rejected, (state) => {
        state.alert = {
          show: true,
          type: 'warning',
          message: 'MSW00005',
        };
      })
      .addCase(logout.rejected, (state) => {
        state.alert = {
          show: true,
          type: 'warning',
          message: 'MSW00006',
        };
      })
      .addCase(logout.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00005',
        };
      })
      .addCase(memberRegisterAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00004',
        };
      })
      .addCase(memberUpdateAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(deleteMemberAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00002',
        };
      })
      .addCase(userRegisterAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00004',
        };
      })
      .addCase(userRegisterAsync.rejected, (state) => {
        state.alert = {
          show: true,
          type: 'error',
          message: 'MSE00048',
        };
      })
      .addCase(dbConfigAsync.fulfilled, (state) => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00007',
        };
      });
  },
});

export default appSlice.reducer;
